import { render } from "./ViewBalanceGuesses.vue?vue&type=template&id=9ace23be&scoped=true"
import script from "./ViewBalanceGuesses.vue?vue&type=script&lang=js"
export * from "./ViewBalanceGuesses.vue?vue&type=script&lang=js"

import "./ViewBalanceGuesses.vue?vue&type=style&index=0&id=9ace23be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ace23be"]])

export default __exports__